export default __webpack_public_path__ + "static/media/minus-light.84fbbef7.svg";